import React from "react";

function Plot_Plotly() {
  return (
    <div>
      <h1>Plot_Plotly Component</h1>
      <p>This is the Plot Plotly tutorial page content.</p>
    </div>
  );
}

export default Plot_Plotly;
